module.exports = __webpack_public_path__ + "img/profile.7dc5013c.svg";